/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PageNotificationsForUserDocument = gql`
    query PageNotificationsForUser($offset: Int, $limit: Int, $action: String) {
  pageNotificationsForUser(offset: $offset, limit: $limit, action: $action) {
    id
    title
    publicUrl
  }
}
    `;

/**
 * __usePageNotificationsForUserQuery__
 *
 * To run a query within a React component, call `usePageNotificationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageNotificationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageNotificationsForUserQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      action: // value for 'action'
 *   },
 * });
 */
export function usePageNotificationsForUserQuery(baseOptions?: Apollo.QueryHookOptions<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>(PageNotificationsForUserDocument, options);
      }
export function usePageNotificationsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>(PageNotificationsForUserDocument, options);
        }
// @ts-ignore
export function usePageNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>;
export function usePageNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<PageNotificationsForUserQuery | undefined, PageNotificationsForUserQueryVariables>;
export function usePageNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>(PageNotificationsForUserDocument, options);
        }
export type PageNotificationsForUserQueryHookResult = ReturnType<typeof usePageNotificationsForUserQuery>;
export type PageNotificationsForUserLazyQueryHookResult = ReturnType<typeof usePageNotificationsForUserLazyQuery>;
export type PageNotificationsForUserSuspenseQueryHookResult = ReturnType<typeof usePageNotificationsForUserSuspenseQuery>;
export type PageNotificationsForUserQueryResult = Apollo.QueryResult<PageNotificationsForUserQuery, PageNotificationsForUserQueryVariables>;
export const MarkPageNotificationsAsViewedDocument = gql`
    mutation MarkPageNotificationsAsViewed($pageIds: [Int!]!, $action: String) {
  markPageNotificationsAsViewed(pageIds: $pageIds, action: $action)
}
    `;
export type MarkPageNotificationsAsViewedMutationFn = Apollo.MutationFunction<MarkPageNotificationsAsViewedMutation, MarkPageNotificationsAsViewedMutationVariables>;

/**
 * __useMarkPageNotificationsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkPageNotificationsAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPageNotificationsAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPageNotificationsAsViewedMutation, { data, loading, error }] = useMarkPageNotificationsAsViewedMutation({
 *   variables: {
 *      pageIds: // value for 'pageIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useMarkPageNotificationsAsViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkPageNotificationsAsViewedMutation, MarkPageNotificationsAsViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPageNotificationsAsViewedMutation, MarkPageNotificationsAsViewedMutationVariables>(MarkPageNotificationsAsViewedDocument, options);
      }
export type MarkPageNotificationsAsViewedMutationHookResult = ReturnType<typeof useMarkPageNotificationsAsViewedMutation>;
export type MarkPageNotificationsAsViewedMutationResult = Apollo.MutationResult<MarkPageNotificationsAsViewedMutation>;
export type MarkPageNotificationsAsViewedMutationOptions = Apollo.BaseMutationOptions<MarkPageNotificationsAsViewedMutation, MarkPageNotificationsAsViewedMutationVariables>;
export type PageNotificationsForUserQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  action?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PageNotificationsForUserQuery = { __typename?: 'Query', pageNotificationsForUser: Array<{ __typename?: 'GraphPage', id?: number | null, title?: string | null, publicUrl?: string | null }> };

export type MarkPageNotificationsAsViewedMutationVariables = Types.Exact<{
  pageIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  action?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MarkPageNotificationsAsViewedMutation = { __typename?: 'Mutation', markPageNotificationsAsViewed: boolean };
